/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  // TODO: find payor's locations
  return [{ id: 1, name: 'Palo Alto' }]
}
